import axios from 'axios';

export const secureAxiosInstance = axios.create();
export const secureAxiosInstanceWithErrorMessageInterceptor = axios.create();
